export namespace MathUtils {

    // Display precision for all converted values. Conversion factors carry floating-point
    // and library-anchor rounding noise beyond ~7 significant figures (e.g. 1 in -> cm comes
    // out as 2.53999991872 instead of 2.54, 1 ft -> m as 0.3047999902464 instead of 0.3048).
    // Rounding to 7 significant figures — the precision Google and standard converters use —
    // yields clean, correct values (2.54, 0.3048, 3.28084, 1.609344) while preserving every
    // legitimately distinct value (e.g. the US survey foot 0.3048006) and small magnitudes.
    const SIGNIFICANT_FIGURES = 7;

    export function roundNumber(num: number): number {
        if (typeof num !== 'number' || !isFinite(num) || num === 0) return num;
        return Number(num.toPrecision(SIGNIFICANT_FIGURES));
    }
}
